import React from "react";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  color?: string; // Tailwind color class
}

const Spinner: React.FC<SpinnerProps> = ({ size = "md", color = "text-white" }) => {
  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    md: "w-6 h-6 border-4",
    lg: "w-8 h-8 border-4",
  };

  return (
    <div
      className={`border-t-transparent border-solid rounded-full animate-spin ${sizeClasses[size]} ${color} border-white`}
    ></div>
  );
};

export default Spinner;
